import { Component, Input } from '@angular/core';

import { AovComparisonProductResult } from '../../lib/services/aov-comparison-product-result';

@Component({
  selector: 'premium-card',
  standalone: false,
  templateUrl: './premium-card.component.html',
  styleUrls: ['./premium-card.component.css']
})
export class PremiumCardComponent {
    @Input() product: AovComparisonProductResult;

    constructor() {
    }
}
